var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-fade',[_c('formulate-errors',{staticClass:"component-form-errors text-body text-skin-danger"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }